class ExpandableTile
    constructor: (el) ->
        @.$el = el
        @.$closerEl = @.$el.querySelector '.expandable-tile__expanded-content__closer'
        @.$expandedContent = @.$el.querySelector '.expandable-tile__expanded-content'
        @.$tile = @.$el.querySelector '.expandable-tile__tile'

        @.expanded = @.$el.classList.contains 'expandable-tile--expanded'

        @.InitEvents()
        @.$el.classList.add 'expandable-tile--bound'
        return

    InitEvents: ->
        self = @
        @.$tile.addEventListener 'click', (e) ->
            self.SetExpandState !self.expanded
            return
        @.$el.addEventListener 'expandable-tile-set-expand-state', (e) ->
            expand = e.detail?.expand ? false
            self.SetExpandState expand
            return
        @.$closerEl.addEventListener 'click', (e) ->
            e.preventDefault()
            self.SetExpandState false
            return
        return

    SetExpandState: (expanded) ->
        @.expanded = expanded
        if expanded
            @.$el.classList.add 'expandable-tile--expanded'
            @.$el.dispatchEvent new CustomEvent 'expandable-tile-expanded', { bubbles: false }
        else
            @.$el.classList.remove 'expandable-tile--expanded'
            @.$el.dispatchEvent new CustomEvent 'expandable-tile-contracted', { bubbles: false }
        return

BindExpandableTiles = ->
    document.querySelectorAll '.expandable-tile:not(.expandable-tile--bound)'
        .forEach (el) ->
            new ExpandableTile el
            return
    return

window.addEventListener 'bind-components', BindExpandableTiles